import { getUserInfo } from '~/api/common.js'
const getCookie = (name, cookie) => {
  let c_start = cookie.indexOf(`${name}=`)
  if (c_start != -1) {
    c_start = c_start + name.length + 1
    let c_end = cookie.indexOf(';', c_start)
    if (c_end == -1) c_end = cookie.length
    return cookie.substring(c_start, c_end)
  }
}
// 需要登录校验的路由地址array
export const requiresUserAuthPath = [
  '/list',
  '/member',
  '/contact/email/send',
  '/contact/sms/send',
  '/contact/merge',
  '/contact/show_history',
  '/contact/sms/detail',
  '/contact/show_history/statistic',
  '/contact/show_history/content',
  '/plugin',
  '/plugin/index',
  '/inner_collect_post',
  '/collect_post/sample_service',
  '/personal/mywrite',
]
let requiresUserAuth = false

// 在服务端页面渲染前，获取登录态，客户端渲染不需要重复操作
export default async function ({ route: { path, fullPath }, store, redirect, req, $config }) {
  if (process.server && !process.static) {
    const sessionid = getCookie('sessionid', req?.headers?.cookie || '')
    try {
      // 检测是否需要用户登录
      requiresUserAuth = requiresUserAuthPath.find((rulePath) => path.includes(rulePath))
      if (sessionid || (!sessionid && requiresUserAuth)) {
        Object.assign($config?._app || {}, { sessionid, cookie: req?.headers?.cookie, signuer: true })
        // 对服务端来说说 每次的SSR 用户都是未登入状态，下面个判断输入多余的
        if (store.state.loginStatus.loggedIn === 0) {
          const { data } = await getUserInfo()
          store.commit('setLoginStatus', { loggedIn: 1, form: 'serveTask' })
          store.commit('setUserInfo', { _init: true, ...data })
        }
      } else {
        Object.assign($config?._app || {}, { sessionid, cookie: req?.headers?.cookie })
      }
    } catch (error) {
      //   console.log('--- 获取用户登录信息失败 --> ', error)
      // 判断是否需要登录校验
      if (requiresUserAuth) {
        redirect(`/login?nexturl=${encodeURIComponent(fullPath)}&from=middleware&status=hassessionid`)
      }
    }
  }
}
